import { AuthModule } from '../../../libs/IdeLink.Web.Common/src/modules/Auth/AuthModule';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { AreasModule } from '../../../xlink/modules/Areas/AreasModule';
import { AuditsModule } from '../../../xlink/modules/Audits/AuditsModule';
import { BackUsersModule } from '../../../xlink/modules/BackUsers/BackUsersModule';
import { ChallengesModule } from '../../../xlink/modules/Challenges/ChallengesModule';
import { CollectionsModule } from '../../../xlink/modules/Collections/CollectionsModule';
import { ContactsModule } from '../../../xlink/modules/Contacts/ContactsModule';
import { EventsModule } from '../../../xlink/modules/Events/EventsModule';
import { FrontUsersModule } from '../../../xlink/modules/FrontUsers/FrontUsersModule';
import { NewsModule } from '../../../xlink/modules/News/NewsModule';
import { OffersModule } from '../../../xlink/modules/Offers/OffersModule';
import { QuizzesModule } from '../../../xlink/modules/Quizzes/QuizzesModule';
import { RolesModule } from '../../../xlink/modules/Roles/RolesModule';
import { SectorsModule } from '../../../xlink/modules/Sectors/SectorsModule';
import { ShopsModule } from '../../../xlink/modules/Shops/ShopsModule';
import { StatsModule } from '../../../xlink/modules/Stats/StatsModule';
import { SurveysModule } from '../../../xlink/modules/Surveys/SurveysModule';
import { TagsModule } from '../../../xlink/modules/Tags/TagsModule';
import { TeamsModule } from '../../../xlink/modules/Teams/TeamsModule';
import { VideosModule } from '../../../xlink/modules/Videos/VideosModule';
import { getPage403Route } from '../../../xlink/scenes/Page403/Page403Route';

export class OxylinkRoutes {
	public static getRoutes = (): Array<RouteItem> => {
		return [
			getPage403Route(),
			...AuthModule.getAuthRoutes(),

			//* ADMIN MODULES
			...BackUsersModule.getBackUsersRoutes(),
			...TeamsModule.getTeamsRoutes(),
			...AreasModule.getAreasRoutes(),
			...SectorsModule.getSectorsRoutes(),
			...ShopsModule.getShopsRoutes(),
			...FrontUsersModule.getFrontUsersRoutes(),
			...StatsModule.getStatsRoutes(),
			...RolesModule.getRolesRoutes(),
			...TagsModule.getTagsRoutes(),

			//* MODULES
			...OffersModule.getOffersRoutes(),
			...NewsModule.getNewsRoutes(),
			...EventsModule.getEventsRoutes(),
			...SurveysModule.getSurveysRoutes(),
			...VideosModule.getVideosRoutes(),
			...ContactsModule.getContactsRoutes(),
			...QuizzesModule.getQuizzesRoutes(),
			...CollectionsModule.getCollectionsRoutes(),
			...ChallengesModule.getChallengesRoutes(),
			...AuditsModule.getAuditsRoutes(),
		];
	};
}
